import { useEffect, useState } from "react";
import { Clock, Loader2, ChevronDown, CheckCircle2, LogIn, LogOut } from "lucide-react";
import { api } from "../../lib/api";

const LABELS = { arrivee: "Arrivée", pause: "Pause", retour: "Retour", depart: "Départ" };
const hhmm = (iso) => { try { return new Date(iso).toLocaleTimeString("fr-FR", { hour: "2-digit", minute: "2-digit" }); } catch { return ""; } };

export function AdminAttendance() {
  const [rows, setRows] = useState(null);
  const [open, setOpen] = useState({});

  useEffect(() => { api.get("/admin/attendance").then(({ data }) => setRows(data)).catch(() => setRows(false)); }, []);

  if (rows === null) return <div className="bg-white border border-brand-line rounded-2xl p-6 flex justify-center"><Loader2 className="w-6 h-6 animate-spin text-brand" /></div>;
  if (rows === false) return null;

  return (
    <div data-testid="admin-attendance" className="bg-white border border-brand-line rounded-2xl p-5 sm:p-6">
      <div className="flex items-center gap-2 mb-4">
        <span className="w-9 h-9 rounded-xl bg-brand/15 text-brand flex items-center justify-center"><Clock className="w-5 h-5" /></span>
        <div>
          <h2 className="font-heading font-bold text-brand-ink">Présences (pointage)</h2>
          <p className="text-xs text-brand-muted">Arrivées et départs des vendeurs.</p>
        </div>
      </div>
      {rows.length === 0 ? <p className="text-sm text-brand-muted">Aucun vendeur.</p> : (
        <div className="space-y-3">
          {rows.map((v) => {
            const arr = v.today.find((p) => p.type === "arrivee");
            const dep = v.today.find((p) => p.type === "depart");
            return (
              <div key={v.seller_id} data-testid={`attendance-row-${v.seller_id}`} className="border border-brand-line rounded-xl px-4 py-3">
                <div className="flex items-center justify-between">
                  <p className="font-semibold text-brand-ink text-sm">{v.name}</p>
                  <div className="flex items-center gap-2 text-xs">
                    {arr ? <span className="inline-flex items-center gap-1 text-green-700"><LogIn className="w-3.5 h-3.5" />{hhmm(arr.time)}</span> : <span className="text-brand-muted">Pas encore arrivé</span>}
                    {dep && <span className="inline-flex items-center gap-1 text-red-600"><LogOut className="w-3.5 h-3.5" />{hhmm(dep.time)}</span>}
                    {v.state.departed && <CheckCircle2 className="w-4 h-4 text-green-600" />}
                  </div>
                </div>
                {v.today.length > 0 && (
                  <div className="flex flex-wrap gap-1.5 mt-2">
                    {v.today.map((p) => (
                      <span key={p.id} className="text-[11px] bg-brand-cream rounded-full px-2 py-0.5 text-brand-sub">{LABELS[p.type]} {hhmm(p.time)}</span>
                    ))}
                  </div>
                )}
                <button onClick={() => setOpen((o) => ({ ...o, [v.seller_id]: !o[v.seller_id] }))} data-testid={`attendance-history-${v.seller_id}`} className="mt-2 inline-flex items-center gap-1 text-xs font-semibold text-brand">
                  Historique <ChevronDown className={`w-3.5 h-3.5 transition-transform ${open[v.seller_id] ? "rotate-180" : ""}`} />
                </button>
                {open[v.seller_id] && (
                  <div className="mt-2 space-y-1.5">
                    {v.history.length === 0 ? <p className="text-xs text-brand-muted">Aucun pointage.</p>
                      : v.history.map((h) => (
                        <div key={h.date} className="text-xs">
                          <span className="font-medium text-brand-ink">{new Date(h.date).toLocaleDateString("fr-FR", { weekday: "short", day: "numeric", month: "short" })}</span>
                          <span className="text-brand-muted ml-2">{h.punches.map((p) => `${LABELS[p.type]} ${hhmm(p.time)}`).join(" · ")}</span>
                        </div>
                      ))}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
